import * as THREE from "three";
import { config } from "../config.js";
import { markScale } from "./scale-view.js";

// 着弾予告(見た目だけ。2026-10-30 段階1「読める」)。
// 敵の弾・突撃中の敵が自機の面(z=0)を通る位置に、だんだん縮む赤い輪を出す。届くまでの時間に合わせて輪が縮む。
// 2026-10-30 オーナー要望で、床の格子・影・自機の足元の輪はやめた(説明的すぎて、距離を読むことに気を取られ没入感が減るため)。
// スケール感(src/sim/scale.js): 輪は倍率の markFollow 乗だけ大きくする(markScale)。

const D = config.graphics.depth;
const C = config.graphics.colors;

export function createDepthCues(scene) {
  const geo = new THREE.RingGeometry(0.86, 1, 28);
  const warnRings = new THREE.InstancedMesh(geo, new THREE.MeshBasicMaterial({ color: C.enemyShotRing, transparent: true, opacity: 0.7, blending: THREE.AdditiveBlending, depthWrite: false, side: THREE.DoubleSide }), 200);
  warnRings.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
  warnRings.frustumCulled = false;
  warnRings.count = 0;
  scene.add(warnRings);

  const m4 = new THREE.Matrix4();
  const q = new THREE.Quaternion();
  const v = new THREE.Vector3();
  const sc = new THREE.Vector3();
  function put(i, x, y, s) {
    sc.setScalar(s);
    m4.compose(v.set(x, y, 0), q, sc);
    warnRings.setMatrixAt(i, m4);
  }

  function update(world) {
    const p = world.player;
    const mark = markScale(world);
    let w = 0;
    for (const sh of world.enemyShots) {
      if (sh.vz <= 0 || w >= 200) continue;
      const t = -sh.z / sh.vz; // 自機の面に来るまでの秒
      if (t < 0 || t > D.warnSeconds) continue;
      const hx = sh.x + sh.vx * t;
      const hy = sh.y + sh.vy * t;
      // 自機に当たりそうな弾だけ(遠く外れる弾まで出すと、かえって読めない)
      if (Math.hypot(hx - p.x, hy - p.y) > D.warnRadius * mark) continue;
      put(w++, hx, hy, (2.5 + 5 * (t / D.warnSeconds)) * mark);
    }
    for (const e of world.enemies) {
      if (e.type !== "dasher" || e.state !== 1 || e.vz <= 0 || w >= 200) continue;
      const t = -e.z / e.vz;
      if (t < 0 || t > D.warnSeconds) continue;
      put(w++, e.x + e.vx * t, e.y + e.vy * t, (5 + 8 * (t / D.warnSeconds)) * mark);
    }
    warnRings.count = w;
    warnRings.instanceMatrix.needsUpdate = true;
  }

  return { update };
}
